import { render, staticRenderFns } from "./BackpackerMedicalModal.vue?vue&type=template&id=3b5c5a60&scoped=true"
import script from "./BackpackerMedicalModal.vue?vue&type=script&lang=js"
export * from "./BackpackerMedicalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5c5a60",
  null
  
)

export default component.exports